<template>
<div class="users">
	<user-line v-for="(user) in sortedList"
		:key="(user.props && user.props.id) || user"
		:user="user"
		:room="room" />
</div>
</template>

<script>
import UserLine from './user-line.vue'
import { reactive } from 'vue'

export default {
	components: {
		UserLine
	},
	props: {
		list: {
			type: Array,
			default: () => []
		},
		room: {
			type: [Object, Boolean],
			default: false
		}
	},
	setup( props ){
		return {
			sortedList: reactive( [] )
		}
	},
	watch: {
		list: {
			immediate: true,
			deep: true,
			async handler( newVal, oldVal ){
				const comparableArray = await Promise.all(
						this.list.map( async( x ) => await getUserById( x ) )
					),
					sorted = comparableArray.sort( ( a, b ) => {
						if( a.props.name < b.props.name ){
							return -1
						} else if( a.props.name > b.props.name ){
							return 1
						}
						return 0
					})
				this.sortedList.splice( 0, this.sortedList.length, ...sorted )
			}
		}
	}
}
</script>

<style>

</style>